var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('factory-order-list',{ref:"orderList",attrs:{"height":this.$tools.mainHeight() - 131,"isRoot":true,"rights":"'b,c,d,e,i,k,m'","canAdd":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }